export default class ScrollReveal extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
  }

  connectedCallback() {
    const items = this.querySelectorAll(`
      .product-card,
      .collection-card,
      .article-card,
      .section-header,
      .section-block,
      .grid > *,
      .shopify-section > *
    `);

    if (!items.length) return;

    items.forEach((item) => {
      item.setAttribute('data-reveal', '');
    });

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            this.observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.05,
        rootMargin: '0px 0px 8% 0px'
      }
    );

    items.forEach((item) => {
      item.style.transitionDelay = '180ms';
      this.observer.observe(item);
    });
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

if (!customElements.get('scroll-reveal')) {
  customElements.define('scroll-reveal', ScrollReveal);
}